import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "@shared/ui/Loader";
import StaticPage from "./StaticPage";
import { useFetchStaticPage } from "../../hooks/useFetchStaticPage";

export function StaticPageContainer() {
  const navigate = useNavigate();
  const { data, isLoading, error, isError } = useFetchStaticPage();

  useEffect(() => {
    if (isError && error) {
      navigate("/not-found");
    }
  }, [isError, error, navigate]);

  if (isLoading) return <Loader isFullPage />;

  if (isError) return null;

  return <StaticPage article={data?.article} />;
}

export default StaticPageContainer;
